import { getPathPrefix } from "utils/getPathPrefix";
import style from "./shapes-no-results.module.css";

export default function ShapesNoResults({ searchTerm }: { searchTerm?: string }) {
  return (
    <div className={style.noSearchResults}>
      <img src={getPathPrefix("/images/no-search-results-glass.png")} alt="no-search-results" />
      <span>No search results for “{searchTerm}”</span>
    </div>
  );
}
